import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-full bg-gradient-to-b from-gray-800 to-black text-white mt-[16rem] sm:mt-1"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full  lg:h-screen">
        <div>
          <p className="text-4xl font-bold inline border-b-4 border-gray-500 ">
            About
          </p>
        </div>

        <p className="text-xl mt-4">
          I am a third-year bachelor of computer science student from the KIET
          group of institutions. I have gained valuable experience in developing
          and maintaining software applications. I have a strong understanding
          of programming languages in C++, fronted web development, and
          methodologies in web development. My technical skills are complemented
          by excellent problem-solving abilities and strong teamwork and
          communication skills. I am always open to leveraging my technical
          expertise and problem-solving abilities in a challenging software
          engineering role. I am seeking a position that allows me to contribute
          to the development of high-quality
        </p>

        <br />

      
      </div>
    </div>
  );
};

export default About;
